import React from "react";

export const FormContext = React.createContext({});

export const FormProvider = FormContext.Provider;
